import React from 'react';
import { useReveal, useCounter } from '../../hooks/useReveal';

export default function HeroStatCard({ raw, label, delay }) {
  const { ref, inView } = useReveal();
  const numMatch = String(raw).match(/\d+/);
  const hasNum = !!numMatch;
  const target = hasNum ? parseInt(numMatch[0], 10) : 0;
  const val = useCounter(target, 1400, inView && hasNum);
  const display = hasNum ? String(raw).replace(/\d+/, val) : raw;

  return (
    <div
      ref={ref}
      className={`reveal ${inView ? 'in-view' : ''} rounded-2xl bg-white border border-[var(--pca-border)] p-4 md:p-5 shadow-[0_10px_30px_-20px_rgba(11,46,110,0.25)]`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="text-2xl md:text-3xl font-extrabold text-[#0B2E6E]">{display}</div>
      <div className="text-slate-500 text-[13px] mt-1 leading-snug">{label}</div>
    </div>
  );
}
